import React, { memo, useMemo } from 'react';
import { Icon, Popover, Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const PublicAccountIndicator = memo(({ isPublic, isReadOnly }) => {
    const theme = useTheme();

    const indicatorConfig = useMemo(() => {
        if (!isPublic) return null;

        if (isReadOnly) {
            return {
                iconName: 'publicLock',
                title: getLiteral('label_detail_public_and_redonly_account'),
                description: getLiteral('label_detail_public_readonly_account_no_edit'),
            };
        }

        return {
            iconName: 'public',
            title: getLiteral('label_detail_public_account'),
            description: getLiteral('label_detail_public_account_desc'),
        };
    }, [isPublic, isReadOnly]);

    const content = useMemo(() => {
        if (!indicatorConfig) return null;

        return (
            <div className="fm-public-account-indicator__content">
                <Text className="fm-public-account-indicator__title" type="subtitle" medium>
                    {indicatorConfig.title}
                </Text>
                <Text
                    className="fm-public-account-indicator__description"
                    color={theme.colors.utility.textSecondary}
                >
                    {indicatorConfig.description}
                </Text>
            </div>
        );
    }, [indicatorConfig, theme.colors.utility.textSecondary]);

    if (!indicatorConfig) return null;

    return (
        <Popover
            className="fm-public-account-indicator"
            placement="bottom"
            content={content}
            trigger={['hover']}
        >
            <div className="fm-public-account-indicator__icon">
                <Icon name={indicatorConfig.iconName} color={theme.colors.grey[500]} />
            </div>
        </Popover>
    );
});

export default PublicAccountIndicator;
